<button #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        type="button"
        class="assignee-pill"
        (click)="toggle()">
  @if (selected(); as collaborator) {
  <span class="assignee-avatar"
        [style.background-color]="color(collaborator)">{{ initials(collaborator) }}</span>
  <span class="assignee-name">{{ name(collaborator) }}</span>
  } @else {
  <span class="assignee-name assignee-name--placeholder">{{ 'message.details.actionRow.unassigned' | translate }}</span>
  }
  <mat-icon class="assignee-chevron">expand_more</mat-icon>
</button>

<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="trigger"
             [cdkConnectedOverlayOpen]="open()"
             [cdkConnectedOverlayHasBackdrop]="true"
             cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             (backdropClick)="close()"
             (attach)="onPanelAttached()"
             (detach)="close()">
  <div class="assignee-panel">
    <div class="assignee-search">
      <mat-icon>search</mat-icon>
      <input #searchInput
             type="text"
             [value]="search()"
             (input)="onSearch($any($event.target).value)"
             [placeholder]="'message.context.searchCollaborator' | translate">
    </div>

    <div class="assignee-list">
      <button type="button"
              class="assignee-option"
              (click)="select(null)">
        <span class="assignee-avatar assignee-avatar--none">
          <mat-icon>person_off</mat-icon>
        </span>
        <span class="assignee-option-name">{{ 'message.details.actionRow.unassigned' | translate }}</span>
        @if (!assignedId()) {
        <mat-icon class="assignee-check">check</mat-icon>
        }
      </button>

      @for (collaborator of filtered(); track collaborator.id) {
      <button type="button"
              class="assignee-option"
              (click)="select(collaborator)">
        <span class="assignee-avatar"
              [style.background-color]="color(collaborator)">{{ initials(collaborator) }}</span>
        <span class="assignee-option-meta">
          <span class="assignee-option-name">{{ name(collaborator) }}</span>
          @if (collaborator.email) {
          <span class="assignee-option-email">{{ collaborator.email }}</span>
          }
        </span>
        @if (collaborator.id === assignedId()) {
        <mat-icon class="assignee-check">check</mat-icon>
        }
      </button>
      } @empty {
      <p class="assignee-empty">{{ 'message.details.actionRow.noResults' | translate }}</p>
      }
    </div>
  </div>
</ng-template>
